<script setup>
import { ref, onMounted } from 'vue';
import { useLayout } from '@/layout/composables/layout';
import AccountUser from '../views/Account.vue';
import { useConfirm } from "primevue/useconfirm";
import { callAPI, DRUPAL_API_ROUTE } from "../service/DrupalService";
import { useRouter } from 'vue-router';
import { useToast } from "primevue/usetoast";

const { toggleMenu, toggleDarkMode, isDarkTheme } = useLayout();
const confirm = useConfirm();
const toast = useToast();
const router = useRouter();
const homepage = import.meta.env.VITE_DRUPAL_URL;

const drawerVisibleAccount = ref(false);
const workspaces = ref([]);
const currentWorkspace = ref();
const user = ref();

function openDrawerAccount() {
  drawerVisibleAccount.value = true;
}

function updateDrawerVisibilityAccount(value) {
  drawerVisibleAccount.value = value;
}

const workspaceSwitchConfirm = () => {
  confirm.require({
    message: "Êtes-vous sûr de vouloir changer d'espace de travail ?",
    header: 'Espace de travail',
    icon: 'pi pi-question-circle',
    rejectProps: {
      label: 'Annuler',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'OK'
    },
    accept: async () => {
      toast.add({ severity: 'info', summary: 'Espace de travail', detail: "Changement d'espace de travail en cours. La page va se recharger automatiquement.", life: 5000 });
      await callAPI(DRUPAL_API_ROUTE.WORKSPACE_CURRENT, {}, { workspace: currentWorkspace.value.id });
      location.reload();
    },
  });
}

onMounted(() => {
  user.value = JSON.parse(localStorage.getItem('user'));
  workspaces.value = JSON.parse(localStorage.getItem('workspaces'));

  var index = workspaces.value.findIndex(workspace => workspace.id == user.value.current_workspace);
  currentWorkspace.value = workspaces.value[index];
});


</script>

<template>
  <AccountUser :visible="drawerVisibleAccount" @update:visible="updateDrawerVisibilityAccount" />
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button class="layout-menu-button layout-topbar-action" @click="toggleMenu">
        <i class="pi pi-bars"></i>
      </button>
      <a :href="homepage" title="Retour au site">
        <img src="@/assets/images/lccx.svg" class="w-20">
      </a>
    </div>
    <div class="flex space-x-6 ml-auto mr-2 max-w-[30%]">
      <Select @change="workspaceSwitchConfirm" v-model="currentWorkspace" filter :options="workspaces"
        optionLabel="name" class="w-full md:w-56">
        <template #value="slotProps">
          <div v-if="slotProps.value" class="flex items-center">
            <img :src="slotProps.value.logo" class="mr-4 w-10" />
            <div>{{ slotProps.value.name }}</div>
          </div>
        </template>
        <template #option="slotProps">
          <div class="flex items-center">
            <img :src="slotProps.option.logo" class="mr-2 w-6" />
            <div>{{ slotProps.option.name }}</div>
          </div>
        </template>
        <template #dropdownicon>
          <i class="pi pi-arrow-circle-down" />
        </template>
      </Select>
    </div>
    <div class="layout-topbar-actions !ml-0">

      <button class="layout-topbar-menu-button layout-topbar-action"
        v-styleclass="{ selector: '@next', enterFromClass: 'hidden', enterActiveClass: 'animate-scalein', leaveToClass: 'hidden', leaveActiveClass: 'animate-fadeout', hideOnOutsideClick: true }">
        <i class="pi pi-ellipsis-v"></i>
      </button>

      <div class="layout-topbar-menu hidden lg:block">
        <div class="layout-topbar-menu-content">
          <button @click="openDrawerAccount" type="button" class="layout-topbar-action">
            <i class="pi pi-user"></i>
            <span>Profile</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
